import React from 'react';

import './index.css';

const IconSort = (props) => {

  return (
    <span className={props.className ? props.className + " icon-sort" : "icon-sort"}>
      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 0L9 5H0L4.5 0Z" fill="#E2ECE7"/>
      </svg>
      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 5L9 0H0L4.5 5Z" fill="#E2ECE7"/>
      </svg>
    </span>
  );
}

export default IconSort;